export function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear().toString();

  return `${day}/${month}/${year}`;
}

export function formatDateISO8601(dateString) {
  if (dateString !== null && dateString !== undefined) {
    const dateObj = new Date(dateString);
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getUTCDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  } else {
    return dateString;
  }
}

export function formatDateMethod2(dateString) {
  const dateObject = new Date(dateString);

  const formattedDate = `${dateObject.getUTCFullYear()}-${String(
    dateObject.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(dateObject.getUTCDate()).padStart(2, "0")}`;

  return formattedDate;
}

export function formatDateMethod3(dateString) {
  const partesData = dateString.split("/");
  const data = new Date(partesData[2], partesData[1] - 1, partesData[0]);

  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");

  const dataFormatada = `${ano}-${mes}-${dia}`;

  return dataFormatada;
}
